module.exports = __webpack_public_path__ + "img/meta_cn.0299f04.jpg";